import { dispatch } from '../Store'
import { Card, ControlMessage, InAppMessage } from '@braze/web-sdk'

export enum BrazeActionType {
	BRAZE_INITIALIZED = 'BRAZE_INITIALIZED',
	NOTIFICATION_SCHEDULER_STARTED = 'NOTIFICATION_SCHEDULER_STARTED',
	CONTENT_CARDS_UPDATED = 'CONTENT_CARDS_UPDATED',
	IN_APP_MESSAGE_RECEIVED = 'IN_APP_MESSAGE_RECEIVED',
	IN_APP_MESSAGE_SHOWN = 'IN_APP_MESSAGE_SHOWN',
	IN_APP_MESSAGE_COOLDOWN_STARTED = 'IN_APP_MESSAGE_COOLDOWN_STARTED',
	IN_APP_MESSAGE_COOLDOWN_COMPLETED = 'IN_APP_MESSAGE_COOLDOWN_COMPLETED',
	INBOX_UPDATE_COOLDOWN_STARTED = 'INBOX_UPDATE_COOLDOWN_STARTED',
	INBOX_UPDATE_COOLDOWN_COMPLETED = 'INBOX_UPDATE_COOLDOWN_COMPLETED',
}

interface BrazeInitialized {
	type: typeof BrazeActionType.BRAZE_INITIALIZED;
	payload?: undefined;
}

interface ContentCardsUpdated {
	type: typeof BrazeActionType.CONTENT_CARDS_UPDATED;
	payload: Card[];
}

interface NotificationSchedulerStarted {
	type: typeof BrazeActionType.NOTIFICATION_SCHEDULER_STARTED;
	payload?: undefined;
}

interface InAppMessageReceived {
	type: typeof BrazeActionType.IN_APP_MESSAGE_RECEIVED;
	payload: InAppMessage | ControlMessage;
}

interface InAppMessageShown {
	type: typeof BrazeActionType.IN_APP_MESSAGE_SHOWN;
	payload: InAppMessage | ControlMessage;
}

interface InAppMessageCooldownStarted {
	type: typeof BrazeActionType.IN_APP_MESSAGE_COOLDOWN_STARTED;
	payload?: undefined;
}

interface InAppMessageCooldownCompleted {
	type: typeof BrazeActionType.IN_APP_MESSAGE_COOLDOWN_COMPLETED;
	payload?: undefined;
}

interface InboxUpdateCooldownStarted {
	type: typeof BrazeActionType.INBOX_UPDATE_COOLDOWN_STARTED;
	payload?: undefined;
}

interface InboxUpdateCooldownCompleted {
	type: typeof BrazeActionType.INBOX_UPDATE_COOLDOWN_COMPLETED;
	payload?: undefined;
}

export type BrazeAction =
	| BrazeInitialized
	| ContentCardsUpdated
	| NotificationSchedulerStarted
	| InAppMessageReceived
	| InAppMessageShown
	| InAppMessageCooldownStarted
	| InAppMessageCooldownCompleted
	| InboxUpdateCooldownStarted
	| InboxUpdateCooldownCompleted;

export const dispatchBrazeAction = (action: BrazeAction) => dispatch(action)
